import { Settings } from "src/types/settings";

export const defaultSettings: Settings = {
    analytics: [],
    api: {
        apiGatewayUrl: "",
        authClientId: "",
        homepageUrl: "",
        paypalClientId: "",
    },
    domain: "",
    envName: "development",
    features: {
        logo: "unknown",
        title: "unknown",
        favicon:
            "data:image/x-icon;base64,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",
        eventChartEnabled: true,
        enviromentLabelEnabled: true,
        pages: {
            devicesPageEnabled: true,
            downloadsPageEnabled: true,
            enrollmentPageEnabled: true,
            filesPageEnabled: true,
            groupsPageEnabled: true,
            ossLicensesPageEnabled: false,
            overviewPageEnabled: true,
            productsPageEnabled: true,
            provisioningPageEnabled: true,
            repositoriesPageEnabled: false,
            rolloutPageEnabled: true,
            universalLicensesPageEnabled: true,
            workspacePageEnabled: true,
        },
        groupPanel: {
            commandsTabEnabled: true,
            enrollmentTabEnabled: true,
            eventsTabEnabled: true,
            filesTabEnabled: true,
            membersTabEnabled: true,
            policyTabEnabled: true,
        },
        devicePanel: {
            appsTabEnabled: true,
            bwcTabEnabled: false,
            commandsTabEnabled: true,
            eventsTabEnabled: true,
            filesTabEnabled: true,
            hardwareTabEnabled: true,
            licenseTabEnabled: true,
            networkTabEnabled: true,
            osTabEnabled: true,
            emteriaServicesSectionEnabled: true,
        },
        enrollmentFlowEnabled: true,
        registrationEnabled: true,
        stripeEnabled: false,
    },
};
